export default function removeTags(text) {
    var regex = /(<([^>]+)>)/ig
    if(text){
        return text.replace(regex, "");
    }else{
        return text
    }
}